// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import store from './store';
import router from './router';
import App from './App';
import './assets/css/animate.min.css';
import './vendor/openseadragon/openseadragon.min';

// import 'jquery';
//MIDI
import { MIDI } from "./vendor/midi.js";
MIDI.loadPlugin({
  soundfontUrl: "./static/soundfont/",
  instrument: "acoustic_grand_piano", // or the instrument code 1 (aka the default)
  onsuccess: function () { }
});

import UtilPlugin from './utils/mixin_plugin';
Vue.use(UtilPlugin);

import VModal from 'vue-js-modal';
Vue.use(VModal);

import gPlugin from 'comps/g_plugin';
Vue.use(gPlugin)

Vue.config.productionTip = false;

import VTooltip from 'v-tooltip'
Vue.use(VTooltip)

router.beforeEach((to, from, next) => {
  //update urlparams
  if (to.name === 'texte-modus' || to.name === 'werbe-modus') {
    store.commit("updateModusDataByUrl", to);
  }
  next();
});

/* eslint-disable no-new */
store.state.eventBus = new Vue();
document.addEventListener('keydown', event => {
  store.state.eventBus.$emit('keydown', event);
});

store.dispatch('setOSDToolTips', OpenSeadragon);

new Vue({
  el: '#app',
  store: store,
  router,
  template: '<App/>',
  components: {
    App
  }
});



// WEBPACK FOOTER //
// ./src/main.js